// The UI text is written in the feminine singular (it started as Michal's game). For male users every
// feminine form below is swapped for its masculine twin, in every text node and in placeholder/title/aria-label
// attributes, including text added later. Only forms that actually differ are listed (e.g. "אהבת"/"שיחקת" read the same).
const WORDS = {
  // imperatives
  בחרי: 'בחר', גררי: 'גרור', הקישי: 'הקש', דייקי: 'דייק', ודייקי: 'ודייק', מקמי: 'מקם', נעצי: 'נעץ', ונעצי: 'ונעץ',
  שלחי: 'שלח', ושלחי: 'ושלח', ייצאי: 'ייצא', לחצי: 'לחץ', נסי: 'נסה', הקלידי: 'הקלד', קבעי: 'קבע', שחקי: 'שחק',
  השיגי: 'השג', התחילי: 'התחל', המשיכי: 'המשך', תרגלי: 'תרגל', סמני: 'סמן', פתחי: 'פתח', גללי: 'גלול', זכרי: 'זכור',
  כתבי: 'כתוב', שמרי: 'שמור', חזרי: 'חזור', הסתכלי: 'הסתכל', קראי: 'קרא', התקרבי: 'התקרב', התרחקי: 'התרחק',
  // future / present
  כשתסיימי: 'כשתסיים', תסיימי: 'תסיים', שולטת: 'שולט', מכירה: 'מכיר', יודעת: 'יודע', זוכרת: 'זוכר', מתקדמת: 'מתקדם',
};
const PHRASES = [['את שולטת', 'אתה שולט'], ['את מכירה', 'אתה מכיר'], ['את יודעת', 'אתה יודע'], ['את זוכרת', 'אתה זוכר']];

export function masc(s) {
  if (!s) return s;
  let out = s;
  for (const [f, m] of PHRASES) if (out.includes(f)) out = out.split(f).join(m);
  // כשאת … → כשאתה …  (handled as phrase prefixes above after splitting; the word map covers the rest)
  return out.replace(/[א-ת]+/g, (w) => WORDS[w] ?? w).replace(/כשאת (שולט|מכיר|יודע|זוכר)/g, 'כשאתה $1');
}

const ATTRS = ['placeholder', 'title', 'aria-label'];
let obs = null;
function fixNode(n) {
  if (n.nodeType === 3) { const t = masc(n.nodeValue); if (t !== n.nodeValue) n.nodeValue = t; return; }
  if (n.nodeType !== 1 || /^(SCRIPT|STYLE)$/.test(n.nodeName)) return;
  for (const a of ATTRS) if (n.hasAttribute(a)) { const v = n.getAttribute(a), t = masc(v); if (t !== v) n.setAttribute(a, t); }
  n.childNodes.forEach(fixNode);
}
/** Turn masculine rewriting on or off. Turning it off needs a re-render by the caller. */
export function setMasculine(on) {
  if (obs) { obs.disconnect(); obs = null; }
  if (!on) return;
  fixNode(document.body);
  obs = new MutationObserver((muts) => {
    obs.disconnect();
    for (const m of muts) {
      if (m.type === 'characterData') fixNode(m.target);
      else if (m.type === 'attributes') fixNode(m.target);
      else m.addedNodes.forEach(fixNode);
    }
    obs.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRS });
  });
  obs.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRS });
}
